import { render, staticRenderFns } from "./Warehouses.vue?vue&type=template&id=db9d4c86&scoped=true&"
import script from "./Warehouses.vue?vue&type=script&lang=ts&"
export * from "./Warehouses.vue?vue&type=script&lang=ts&"
import style0 from "./Warehouses.vue?vue&type=style&index=0&id=db9d4c86&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db9d4c86",
  null
  
)

export default component.exports